module.exports = __webpack_public_path__ + "img/monitor8.fc687dd9.jpg";